import * as React from 'react';

import { DeviceInfoContext } from '@/contexts/device-info-context';

function MoneyExchangeIcon(props) {
  const { isMobile } = React.useContext(DeviceInfoContext);

  return isMobile ? (
    <svg width={32} height={32} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <rect width={16} height={16} rx={8} fill='url(#prefix__paint0_linear_211_1717)' />
      <rect x={16} y={16} width={16} height={16} rx={8} fill='url(#prefix__paint1_linear_211_1717)' />
      <path
        d='M20.667 20.456c0-.252.216-.456.483-.456h5.797c.266 0 .483.204.483.456v.911c0 .252-.217.456-.483.456H21.15c-.267 0-.483-.204-.483-.456v-.911zM20.667 23.19c0-.251.216-.455.483-.455h5.797c.266 0 .483.204.483.456v.911c0 .252-.217.456-.483.456H21.15c-.267 0-.483-.204-.483-.456v-.911z'
        fill='#fff'
      />
      <path
        d='M24.47 22.735c.234 0 .424.175.424.39v4.689c0 .216-.19.39-.423.39h-.846c-.233 0-.422-.174-.422-.39v-4.688c0-.216.19-.391.422-.391h.846z'
        fill='#fff'
      />
      <g filter='url(#prefix__filter0_bi_211_1717)'>
        <path
          d='M21.666 4.394v-3.16c0-.315-.126-.632-.378-.874a1.318 1.318 0 00-.913-.36c-.331 0-.662.12-.913.36l-8.129 7.665 8.129 7.663c.251.24.582.361.913.361.33 0 .661-.12.913-.361s.378-.558.378-.873v-3.073c3.552.084 7.434.699 10.334 4.925v-1.235c0-5.72-4.521-10.423-10.334-11.038z'
          fill='#72BF44'
          fillOpacity={0.5}
        />
      </g>
      <g filter='url(#prefix__filter1_bi_211_1717)'>
        <path
          d='M10.334 27.606v3.16c0 .316.126.632.378.874.252.24.583.36.913.36.331 0 .662-.12.914-.36l8.128-7.665-8.129-7.663a1.32 1.32 0 00-.913-.361c-.33 0-.661.12-.913.361s-.378.558-.378.873v3.073C6.782 20.174 2.9 19.559 0 15.333v1.235c0 5.72 4.521 10.423 10.334 11.038z'
          fill='#72BF44'
          fillOpacity={0.5}
        />
      </g>
      <path
        d='M10.278 9.344c0 .84-.618 1.567-1.752 1.822-.138.031-.24.14-.24.267v.546c0 .145-.13.263-.29.263H7.48c-.161 0-.291-.118-.291-.263v-.444c0-.141-.123-.256-.278-.27a5.106 5.106 0 01-1.428-.325.235.235 0 01-.142-.284l.188-.662c.047-.166.255-.247.43-.179.427.167.953.296 1.52.296.638 0 1.075-.222 1.075-.626 0-.384-.358-.628-1.187-.88-1.196-.364-2.014-.868-2.014-1.847 0-.83.605-1.492 1.658-1.75.135-.033.233-.14.233-.265v-.48c0-.145.13-.263.292-.263h.514c.16 0 .29.118.29.263v.375c0 .14.123.255.278.268.474.04.838.126 1.128.23a.241.241 0 01.158.294l-.181.638c-.044.156-.23.236-.396.177a3.762 3.762 0 00-1.3-.225c-.727 0-.961.282-.961.566 0 .333.391.545 1.342.869 1.332.423 1.87.979 1.87 1.889z'
        fill='#fff'
      />
      <defs>
        <linearGradient
          id='prefix__paint0_linear_211_1717'
          x1={0}
          y1={0}
          x2={13.952}
          y2={-1.622}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#4FB84E' />
          <stop offset={1} stopColor='#2A8640' />
        </linearGradient>
        <linearGradient
          id='prefix__paint1_linear_211_1717'
          x1={16}
          y1={16}
          x2={29.952}
          y2={14.378}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#4FB84E' />
          <stop offset={1} stopColor='#2A8640' />
        </linearGradient>
        <filter
          id='prefix__filter0_bi_211_1717'
          x={7.333}
          y={-4}
          width={28.667}
          height={24.666}
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feGaussianBlur in='BackgroundImageFix' stdDeviation={2} />
          <feComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur_211_1717' />
          <feBlend in='SourceGraphic' in2='effect1_backgroundBlur_211_1717' result='shape' />
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dx={0.2} dy={0.1} />
          <feGaussianBlur stdDeviation={0.5} />
          <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
          <feColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0' />
          <feBlend in2='shape' result='effect2_innerShadow_211_1717' />
        </filter>
        <filter
          id='prefix__filter1_bi_211_1717'
          x={-4}
          y={11.334}
          width={28.667}
          height={24.666}
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feGaussianBlur in='BackgroundImageFix' stdDeviation={2} />
          <feComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur_211_1717' />
          <feBlend in='SourceGraphic' in2='effect1_backgroundBlur_211_1717' result='shape' />
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dx={0.2} dy={0.1} />
          <feGaussianBlur stdDeviation={0.5} />
          <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
          <feColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0' />
          <feBlend in2='shape' result='effect2_innerShadow_211_1717' />
        </filter>
      </defs>
    </svg>
  ) : (
    <svg width={72} height={72} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <rect x={12} y={12} width={24} height={24} rx={12} fill='url(#prefix__paint0_linear_70_6795)' />
      <rect x={36} y={36} width={24} height={24} rx={12} fill='url(#prefix__paint1_linear_70_6795)' />
      <path
        d='M43 42.684c0-.378.324-.684.725-.684h8.694c.4 0 .725.306.725.684v1.367c0 .378-.324.684-.724.684h-8.695c-.4 0-.725-.306-.725-.684v-1.367zM43 46.786c0-.377.324-.684.725-.684h8.694c.4 0 .725.307.725.684v1.368c0 .377-.324.683-.724.683h-8.695c-.4 0-.725-.306-.725-.683v-1.368z'
        fill='#fff'
      />
      <path
        d='M48.706 46.102c.35 0 .634.263.634.587v7.032c0 .324-.284.586-.634.586h-1.268c-.35 0-.634-.262-.634-.586V46.69c0-.324.284-.587.634-.587h1.268z'
        fill='#fff'
      />
      <g filter='url(#prefix__filter0_bi_70_6795)'>
        <path
          d='M44.5 18.59v-4.738c0-.474-.19-.948-.568-1.311a1.977 1.977 0 00-1.37-.541c-.495 0-.991.18-1.37.54L29 24.038l12.193 11.495c.378.36.873.542 1.37.542.495 0 .991-.181 1.37-.542a1.81 1.81 0 00.567-1.31v-4.609c5.328.126 11.15 1.048 15.5 7.387v-1.852c0-8.58-6.781-15.635-15.5-16.557z'
          fill='#72BF44'
          fillOpacity={0.5}
        />
      </g>
      <g filter='url(#prefix__filter1_bi_70_6795)'>
        <path
          d='M27.5 53.41v4.738c0 .474.19.948.568 1.311.377.361.873.541 1.37.541.495 0 .992-.18 1.37-.54L43 47.962 30.807 36.468a1.979 1.979 0 00-1.37-.542c-.495 0-.992.181-1.37.542a1.81 1.81 0 00-.567 1.31v4.609C22.172 42.261 16.35 41.339 12 35v1.852c0 8.58 6.781 15.635 15.5 16.557z'
          fill='#72BF44'
          fillOpacity={0.5}
        />
      </g>
      <path
        d='M27.418 26.016c0 1.261-.927 2.35-2.629 2.734-.206.046-.36.208-.36.4v.819c0 .217-.195.394-.436.394h-.772c-.24 0-.436-.177-.436-.394v-.667c0-.211-.184-.383-.416-.404-.817-.074-1.586-.259-2.143-.489a.352.352 0 01-.212-.425l.282-.992c.07-.25.383-.371.644-.27.64.252 1.43.445 2.281.445.957 0 1.612-.334 1.612-.94 0-.576-.537-.941-1.78-1.32-1.795-.545-3.021-1.302-3.021-2.77 0-1.246.907-2.238 2.487-2.625.201-.049.35-.209.35-.397v-.72c0-.219.195-.395.436-.395h.772c.24 0 .436.176.436.394v.562c0 .211.184.383.417.403.71.059 1.256.188 1.691.344.193.07.29.26.238.442l-.273.957c-.066.234-.345.354-.593.265a5.645 5.645 0 00-1.95-.337c-1.09 0-1.443.424-1.443.848 0 .5.588.818 2.014 1.304 1.999.635 2.804 1.469 2.804 2.834z'
        fill='#fff'
      />
      <defs>
        <linearGradient
          id='prefix__paint0_linear_70_6795'
          x1={12}
          y1={12}
          x2={32.928}
          y2={9.567}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#4FB84E' />
          <stop offset={1} stopColor='#2A8640' />
        </linearGradient>
        <linearGradient
          id='prefix__paint1_linear_70_6795'
          x1={36}
          y1={36}
          x2={56.928}
          y2={33.568}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#4FB84E' />
          <stop offset={1} stopColor='#2A8640' />
        </linearGradient>
        <filter
          id='prefix__filter0_bi_70_6795'
          x={25}
          y={8}
          width={39}
          height={33}
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feGaussianBlur in='BackgroundImageFix' stdDeviation={2} />
          <feComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur_70_6795' />
          <feBlend in='SourceGraphic' in2='effect1_backgroundBlur_70_6795' result='shape' />
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dx={0.2} dy={0.1} />
          <feGaussianBlur stdDeviation={0.5} />
          <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
          <feColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0' />
          <feBlend in2='shape' result='effect2_innerShadow_70_6795' />
        </filter>
        <filter
          id='prefix__filter1_bi_70_6795'
          x={8}
          y={31}
          width={39}
          height={33}
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feGaussianBlur in='BackgroundImageFix' stdDeviation={2} />
          <feComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur_70_6795' />
          <feBlend in='SourceGraphic' in2='effect1_backgroundBlur_70_6795' result='shape' />
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dx={0.2} dy={0.1} />
          <feGaussianBlur stdDeviation={0.5} />
          <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
          <feColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0' />
          <feBlend in2='shape' result='effect2_innerShadow_70_6795' />
        </filter>
      </defs>
    </svg>
  );
}

export default MoneyExchangeIcon;
